import axios from "axios";
import { logout } from "../lib/auth";

import { EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";

// 外部エントリーフォーム - SMS一覧取得
export async function getOutsideEntryFormSMSs(id: string) {
  try {
    const path = "outsideEntryFormSMSs";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return { sudDatas: [] };
    }
    return { sudDatas: response.data.fetch_data };
  } catch (error) {
    return { sudDatas: [] };
    // logout();
  }
}
// 外部エントリーフォーム - SMS詳細取得
export async function getOutsideEntryFormSMS(id: string) {
  try {
    const path = "outsideEntryFormSMS";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {}
}
// 外部エントリーフォーム - SMS詳細編集
export async function putOutsideEntryFormSMS(editData: EditDataDifine) {
  try {
    const path = "outsideEntryFormSMS";
    const params = { id: editData.id };
    const bodys = {
      id: editData.id,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
      payment_method_id: editData.payment_method_id,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部エントリーフォーム - SMS登録
export async function postOutsideEntryFormSMS(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryFormSMS";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部エントリーフォーム - SMS削除
export async function deleteOutsideEntryFormSMS(id: string) {
  try {
    const path = "outsideEntryFormSMS";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}
